import styled from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

export const Container = styled.div`
  border: 1px solid ${colors.alert};
  border-radius: 0.375rem;
  background: rgba(238, 90, 90, 0.1);
  padding: 1rem;
  display: flex;

  > div {
    padding-left: 1rem;
  }

  ul {
    padding-left: 1.25rem;
  }

  li {
    display: list-item;
    color: ${colors.black1};
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/ProductPrice/InfoBlock.style.tsx